import type { Params, DimensionUnit } from '../../lib/types';
import { Select, Slider, Toggle, NumberPair } from './widgets';

export function OutputGroup({ params, setParam }: { params: Params; setParam: <K extends keyof Params>(k: K, v: Params[K]) => void }) {
  return (
    <>
      <NumberPair label="Output dimensions" w={params.outputWidth} h={params.outputHeight} lock
        onW={(v) => setParam('outputWidth', v)} onH={(v) => setParam('outputHeight', v)} onLock={() => {}} />
      <Select<DimensionUnit> label="Unit" value={params.outputUnit} options={[['px', 'px'], ['mm', 'mm'], ['in', 'in']]} onChange={(v) => setParam('outputUnit', v)} />
      <Slider label="Decimal precision" min={0} max={6} step={1} value={params.decimalPrecision} onChange={(v) => setParam('decimalPrecision', v)} />
      <Toggle label="Pretty print" value={params.prettyPrint} onChange={(v) => setParam('prettyPrint', v)} />
      <Toggle label="Embed viewBox only" value={params.viewBoxOnly} onChange={(v) => setParam('viewBoxOnly', v)} />
      <label className="block text-sm">
        <span className="mb-1 block">Background fill</span>
        <input type="text" value={params.outputBgFill} onChange={(e) => setParam('outputBgFill', e.target.value)} className="w-full rounded border border-[var(--border)] bg-[var(--entry)] px-2 py-1" placeholder="transparent or #rrggbb" />
      </label>
    </>
  );
}
